/**
 * First letters of the first two words: "Serhat Perkmen" -> "SP".
 * Falls back to whatever it is given, so an email works too.
 */
export function initialsFrom(value) {
  return (value || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join("");
}
